import { ValidationError } from 'yup';
import { IOrderQuotation } from '../order-quotation-form';

// The single price rule, kept in lockstep with the backend
// (OrderQuotationsService.isLinePriceValid) and the acceptance preview: EXACTLY
// ONE of kilo_price / group_price is greater than zero and the other is exactly
// zero. Both zero (no price), both positive (ambiguous), and negatives are all
// invalid. Since negatives are rejected first, "exactly one positive" reduces to
// an XOR. See the plan, "Make price validation consistent".
export function isKiloPriceAndGroupPriceDifferentThanZero(
    value: any,
    context: any,
): boolean | ValidationError {
    const { kilo_price, group_price } = context.from[0]
        .value as IOrderQuotation['order_quotation_products'][number];

    const kilo = Number(kilo_price);
    const group = Number(group_price);

    if (Number.isNaN(kilo) || Number.isNaN(group)) {
        return true;
    }

    if (kilo < 0 || group < 0) {
        return context.createError({
            message: `El precio no puede ser negativo`,
        });
    }

    const kiloPositive = kilo > 0;
    const groupPositive = group > 0;

    // XOR: exactly one positive. Both zero or both positive is invalid.
    if (kiloPositive === groupPositive) {
        return context.createError({
            message: `Debe capturar exactamente un precio (por kilo o por bulto), el otro en cero`,
        });
    }

    return true;
}
